<kendo-card class="frequency-card">
  <kendo-card-header class="k-hstack">
    <div>
      <h1 kendoCardTitle><kendo-icon name="home"></kendo-icon> F: {{ refNumber }}</h1>
      <p kendoCardSubtitle> Device:        {{ used }} </p>

    </div>
  </kendo-card-header>
  <hr kendoCardSeparator/>
  <kendo-card-body>

    <p style="color:#231ba4;">
      Status:  <small>  {{ status }}</small><sup> ( {{ fqStatus.status }} )</sup> <br/>
      Freq:   {{ fqStatus.frequency.toFixed(5)   }} <br/>
      Raw:   {{ fqStatus.rawdata }} <br/>
    </p>


  </kendo-card-body>

    <kendo-card-footer >
      </kendo-card-footer>

</kendo-card>



